// German for the standing-facts zone of the client page. Registered on load.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Recorded — the previous value of {key} moved into its history': 'Erfasst — der bisherige Wert von {key} ist in die Historie gewandert',
  'Fact recorded': 'Fakt erfasst',
  'Fact updated': 'Fakt aktualisiert',
  'Confirmed — {key} is operator-reviewed (audit log has the touch).': 'Bestätigt — {key} ist vom Operator geprüft (der Prüfpfad hält es fest).',
  '{key} retracted — the row stays in the history.': '{key} zurückgezogen — die Zeile bleibt in der Historie.',
  'Deleted — the previous value of {key} is current again': 'Gelöscht — der bisherige Wert von {key} ist wieder aktuell',
  'Deleted {key}': '{key} gelöscht',
  'as of {date}': 'Stand {date}',
  'source': 'Quelle',
  'Recorded by the reconstruction agent — always yours to correct': 'Vom Rekonstruktions-Agenten erfasst — jederzeit von Ihnen korrigierbar',
  'agent': 'Agent',
  'retracted': 'zurückgezogen',
  'no current value — {n} historical row': 'kein aktueller Wert — {n} historische Zeile',
  'no current value — {n} historical rows': 'kein aktueller Wert — {n} historische Zeilen',
  'Recorded by an agent pass, never confirmed by a human': 'Von einem Agenten-Durchgang erfasst, nie von einem Menschen bestätigt',
  'Held — a human stands behind this value': 'Gehalten — ein Mensch steht hinter diesem Wert',
  'unconfirmed': 'unbestätigt',
  'no date': 'ohne Datum',
  'stated by {name}': 'genannt von {name}',
  'no speaker attributed': 'keine sprechende Person zugeordnet',
  'extracted from the document — no speaker attributed': 'aus dem Dokument extrahiert — keine sprechende Person zugeordnet',
  '{n} earlier value': '{n} früherer Wert',
  '{n} earlier values': '{n} frühere Werte',
  'Keep this agent-recorded value — one audited click': 'Diesen vom Agenten erfassten Wert behalten — ein protokollierter Klick',
  'Confirm': 'Bestätigen',
  'Edit value, as-of, stated-by or quote': 'Wert, Stand, Nennung oder Zitat bearbeiten',
  'Edit': 'Bearbeiten',
  'Retract — wrong or withdrawn; the row stays in the history': 'Zurückziehen — falsch oder widerrufen; die Zeile bleibt in der Historie',
  'Retract': 'Zurückziehen',
  'Delete — the previous value becomes current again': 'Löschen — der bisherige Wert wird wieder aktuell',
  'Delete this fact': 'Diesen Fakt löschen',
  'Delete': 'Löschen',
  'Stated by': 'Genannt von',
  'Quote — verbatim from the source document, or empty': 'Zitat — wörtlich aus dem Quelldokument, oder leer',
  'Saving…': 'Wird gespeichert…',
  'Save': 'Speichern',
  'Cancel': 'Abbrechen',
  'Delete this historical row — the chain re-links around it': 'Diese historische Zeile löschen — die Kette schliesst sich um sie herum',
  'What we currently know': 'Was wir derzeit wissen',
  '{n} standing fact': '{n} Fakt',
  '{n} standing facts': '{n} Fakten',
  '{n} unconfirmed': '{n} unbestätigt',
  'Show only the values an agent recorded and nobody has confirmed': 'Nur die Werte zeigen, die ein Agent erfasst und niemand bestätigt hat',
  'Only unconfirmed ({n})': 'Nur unbestätigte ({n})',
  'The catalog’s standing fields that hold no value yet — the briefing form, with its blanks': 'Die Katalogfelder, die noch keinen Wert haben — das Briefing-Formular mit seinen Lücken',
  'Hide the empty fields': 'Leere Felder ausblenden',
  'Show the empty fields': 'Leere Felder einblenden',
  'Add fact': 'Fakt hinzufügen',
  'Nothing recorded yet — run a reconstruct pass. Facts are the latest known instance of each negotiable — fee, scope bound, lead time — each with its as-of date and source document.': 'Noch nichts erfasst — starten Sie einen Rekonstruktions-Durchgang. Fakten sind der jeweils letzte bekannte Stand jedes Verhandlungspunkts — Honorar, Umfangsgrenze, Vorlaufzeit — mit Stichtag und Quelldokument.',
  'Money': 'Geld',
  'Timing': 'Zeitplan',
  'Solution': 'Lösung',
  'People': 'Personen',
  'Relationship': 'Beziehung',
  'Facts recorded under novel keys — outside the standing catalog': 'Fakten unter neuen Schlüsseln — ausserhalb des Katalogs',
  'Client-specific': 'Kundenspezifisch',
  'Record a fact': 'Fakt erfassen',
  'Key — a standing catalog field; reuse an existing key to supersede its value': 'Schlüssel — ein Katalogfeld; einen bestehenden Schlüssel wiederverwenden, um dessen Wert abzulösen',
  'Client-specific (novel key) — standing fields have priority; tick only when none fits': 'Kundenspezifisch (neuer Schlüssel) — Katalogfelder haben Vorrang; nur ankreuzen, wenn keines passt',
  'Value — as stated, with units and qualifiers': 'Wert — wie genannt, mit Einheiten und Einschränkungen',
  '18.5k CHF/yr excl. VAT, final offer': '18.5k CHF/Jahr exkl. MwSt., letztes Angebot',
  'As of': 'Stand',
  'Source document — mandatory; where the value is stated': 'Quelldokument — Pflicht; wo der Wert genannt wird',
  '— pick a document —': '— Dokument wählen —',
  'Quote — optional, but must be verbatim from the document': 'Zitat — optional, aber wörtlich aus dem Dokument',
  'Checked character-for-character against the document’s extracted text — a paraphrase is rejected.': 'Wird Zeichen für Zeichen gegen den extrahierten Text des Dokuments geprüft — eine Paraphrase wird abgelehnt.',
  'Recording…': 'Wird erfasst…',
  'Record fact': 'Fakt erfassen',
  'Delete fact': 'Fakt löschen',
  'Deleting…': 'Wird gelöscht…',
  'Delete this value of {key}?': 'Diesen Wert von {key} löschen?',
  'The previous value in the chain becomes current again.': 'Der vorherige Wert in der Kette wird wieder aktuell.',
  'The rest of the chain re-links around it.': 'Der Rest der Kette schliesst sich um ihn herum.',
  'The audit log keeps the record.': 'Der Prüfpfad behält den Eintrag.',
}, 'ClientFactsPanel');
